
<div class="aab mxx-8">
    <div class="product-gallery__featured dots">
    <!--<button *ngIf="productLayout !== 'quickview'" class="product-gallery__zoom" (click)="openPhotoSwipe(currentItem)">
        <app-icon name="zoom-in-24" size="24"></app-icon>
    </button>
     <button type="button" class="btn btn-control prev" (click)="direction.isRTL() ? featuredCarousel.next() : featuredCarousel.prev()"><mat-icon>chevron_left</mat-icon></button>
    <button type="button" class="btn btn-control next" (click)="direction.isRTL() ? featuredCarousel.prev() : featuredCarousel.next()"><mat-icon>chevron_right</mat-icon></button> -->
        <owl-carousel-o *ngIf="items?.length > 0; else noImage" [options]="carouselOptions" (changed)="featuredCarouselTranslated($event)" appOwlPreventClick #featuredCarousel>
        <!--suppress AngularUndefinedBinding -->
        <ng-template *ngFor="let item of items; let index = index" carouselSlide [id]="item.id">
            <div class="product-image product-image--location--gallery">
                <div appClick class="product-image__body {{imageRatio}}"  (click)="openPhotoSwipe(item)">
                    <!--
                    The data-width and data-height attributes must contain the size of a larger version
                    of the product image.

                    If you do not know the image size, you can remove the data-width and data-height
                    attribute, in which case the width and height will be obtained from the naturalWidth
                    and naturalHeight property of img.product-image__img.
                    -->
                    <img class="product-image__img" [src]="item.image" #imageElement [alt]="titleService.getTitle()">
                </div>
            </div>
        </ng-template>
    </owl-carousel-o>

    <ng-template #noImage>
        <div class="product-image product-image--location--gallery">
            <div class="product-image product-image--location--gallery">
                <div class="product-image__body {{imageRatio}}">
                    <img class="product-image__img" [src]="image" #imageElement  [alt]="titleService.getTitle()">
                </div>
            </div>

        </div>
    </ng-template></div>

</div>


<!-- <div class="product-gallery__carousel hidden">
    <owl-carousel-o appOwlPreventClick [options]="getThumbnailsOptions()" [appFakeSlides]="items.length" #fakeSlides="appFakeSlides" #thumbnailsCarousel>
        <ng-template *ngFor="let item of items" carouselSlide [id]="item.id">
            <div appClick class="product-image product-gallery__carousel-item" [class.product-gallery__carousel-item--active]="item === currentItem" (click)="onThumbnailImageClick(item)">
                <div class="product-image__body {{imageRatio}}">
                    <img class="product-image__img product-gallery__carousel-image" [src]="item.image" alt="">
                </div>
            </div>
        </ng-template>
        <ng-template *ngFor="let i of fakeSlides.slides" carouselSlide [id]="'fake-slide-'+i"></ng-template>
    </owl-carousel-o>
</div> -->



